import { Component, VERSION } from '@angular/core';

import { environment } from '@app/environment';
import version from '../version.json';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})
export class AppComponent {
	isProduction = environment.production;

	angularVersion = VERSION.full;
	appVersion = version.build;
}
